import React from 'react'
import './App.css'
import {createMuiTheme, CssBaseline} from '@material-ui/core'
import {ThemeProvider} from '@material-ui/styles'
import './editor'
import {GameSurface} from './game-surface'
import './patch'
import './rocket'
import './meteor'
import './background'
import './system'
import './clouds'
import './planets'
import './land'
import './game-manager'

import {raise} from './events'

const darkTheme = createMuiTheme({
    palette: {
        type: 'light',
    },
})

function App() {
    console.log("App")
    raise('initializeGame')
    return (
        <ThemeProvider theme={darkTheme}>
            <CssBaseline/>
            <GameSurface/>
        </ThemeProvider>
    )
}

export default App
